import {
  FaSeedling,
  FaFish,
  FaBox,
  FaCapsules,
  FaShip,
  FaTruck,
  FaClipboardList,
  FaCheckCircle,
} from "react-icons/fa";

export const KPI_ICONS = {
  CPIB: <FaSeedling size={18} color="white" />,
  CBIB: <FaFish size={18} color="white" />,
  CPPIB: <FaBox size={18} color="white" />,
  CPOIB: <FaCapsules size={18} color="white" />,
  KAPAL: <FaShip size={18} color="white" />,
  CDOIB: <FaTruck size={18} color="white" />,
  MOHON: <FaClipboardList size={18} color="white" />,
  TERBIT: <FaCheckCircle size={18} color="white" />,
};
